import type { FaireProductEntity } from "../../entity_types/product";

export const p_live_algae_cooking_club_shiitake_mushroom_oil: FaireProductEntity =
  {
    token: "p_live_algae_cooking_club_shiitake_mushroom_oil",
    type: "product",
    name: "Shiitake Mushroom Oil",
    brandToken: "b_live_algae_cooking_club",
    brandName: "Algae Cooking Club",
    imageUrl:
      "https://cdn.faire.com/fastly/976c63272d5a42fbe8b32caa2d65af6a1532ef1ae7c4b69bad5c5be4bcf12496.png?bg-color=FFFFFF&fit=crop&format=jpg&height=400&width=400",
    priceDollars: 8.5,
    msrpDollars: 17,
    description:
      "Algae Cooking Club shiitake mushroom oil used in Live Shopping mocks.",
    categoryTokens: ["cat_food-drink"],
    tags: ["live-shopping", "exclusive", "oils"],
    meta: {
      source: "mock",
      importedAt: "2026-03-24T00:00:00.000Z",
      importedBy: "live-shopping-migration",
    },
  };
